import { drawSelection, dropCursor, highlightSpecialChars, keymap, lineNumbers as cmLineNumbers, } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
import { defaultKeymap, history, historyKeymap } from '@codemirror/commands';
export function buildMinimalSetup(opts) {
    if (opts === false)
        return [];
    const o = typeof opts === 'object' ? opts : {};
    const exts = [
        highlightSpecialChars(),
        history(),
        drawSelection(),
        EditorState.allowMultipleSelections.of(o.allowMultipleSelections === true),
    ];
    if (o.lineNumbers)
        exts.push(cmLineNumbers());
    if (o.dropCursor !== false)
        exts.push(dropCursor());
    if (o.defaultKeymap !== false) {
        exts.push(keymap.of([...defaultKeymap, ...historyKeymap]));
    }
    return exts;
}
